import script from "./X1DashboardCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./X1DashboardCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./X1DashboardCalendar.vue?vue&type=style&index=0&id=148c45cc&lang=css&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-148c45cc"]])

export default __exports__